export default __webpack_public_path__ + "static/video-thumbnail-19ef3a41f393a3dacec600104a88a09d.jpg";